var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBahnhof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Bahnhof__Icn/40px/Legende/Bahnhof",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Bahnhof__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende_Bahnhof__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,10 C25.5228475,10 30,14.4771525 30,20 C30,25.5228475 25.5228475,30 20,30 C14.4771525,30 10,25.5228475 10,20 C10,14.4771525 14.4771525,10 20,10 Z M20,12 C15.581722,12 12,15.581722 12,20 C12,24.418278 15.581722,28 20,28 C24.418278,28 28,24.418278 28,20 C28,15.581722 24.418278,12 20,12 Z M18.0204778,15 L18.0204778,18.9385666 L21.9795222,18.9385666 L21.9795222,15 L24,15 L24,25.0068259 L21.9795222,25.0068259 L21.9795222,20.6313993 L18.0204778,20.6313993 L18.0204778,25.0068259 L16,25.0068259 L16,15 L18.0204778,15 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Bahnhof__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBahnhof);
export default __webpack_public_path__ + "static/media/Bahnhof.18b1ae41032b4c271519864a4f3a79c5.svg";
export { ForwardRef as ReactComponent };